import * as React from "react";

const SvgAtsymbol = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M16 12a4 4 0 1 0-8 0 4 4 0 0 0 8 0Z" />
      <path d="M16 12v1.5a2.5 2.5 0 0 0 5 0V12a9 9 0 1 0-9 9M16.5 19.794a8.959 8.959 0 0 1-4.5 1.208" />
    </g>
  </svg>
);

export default SvgAtsymbol;
